// extracted by mini-css-extract-plugin
export var completionBody = "_lc-2";
export var completionCard = "_lc-0";
export var completionFooter = "_lc-3";
export var completionTitle = "_lc-1";